import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { useAdminColors } from '@/hooks/admin/useAdminColors';

interface AvatarInitialsProps {
  firstName?: string;
  lastName?: string;
  size?: number; // diameter in px
  backgroundColor?: string;
  textColor?: string;
}

export const AvatarInitials: React.FC<AvatarInitialsProps> = ({
  firstName,
  lastName,
  size = 48,
  backgroundColor,
  textColor,
}) => {
  const { admin } = useAdminColors();
  const resolvedBg = backgroundColor ?? admin.selector.itemSelectedBg;
  const resolvedColor = textColor ?? admin.formInput.borderFocused;

  const initials = React.useMemo(() => {
    const f = firstName?.charAt(0)?.toUpperCase() || '';
    const l = lastName?.charAt(0)?.toUpperCase() || '';
    return f + l || '??';
  }, [firstName, lastName]);

  return (
    <View
      style={[
        styles.avatar,
        { width: size, height: size, borderRadius: size / 2, backgroundColor: resolvedBg },
      ]}
    >
      <Text scale="micro" style={[styles.text, { color: resolvedColor, fontSize: Math.max(12, size * 0.375) }]}>
        {initials}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  avatar: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    fontWeight: '600',
  },
});
